import React, { useState } from 'react';
import ReactPlayer from 'react-player/file';

import {
  IconButton,
  makeStyles,
  Grid,
  Slider,
  withStyles
} from '@material-ui/core';

import {
  PlayArrow,
  Pause,
  VolumeDown,
  VolumeUp,
  VolumeMute,
  VolumeOff
} from '@material-ui/icons/';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  play: {
    color: '#ffffff',
    fontSize: '30px',
  },
  player: {
    backgroundColor: '#2C3E50',
    borderRadius: '14px',
    marginTop: '15px'
  }
}));

const PrettoSlider = withStyles({
  root: {
    color: 'rgba(255,255,255,.7)',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid #fff',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const Player = (props) => {
  const {
    anexo,
    width = '100%',
    height
  } = props;
  const ref = React.createRef();
  const [player, setPlayer] = useState({
    url: `${process.env.REACT_APP_BACKEND_IMG}${anexo.caminho}`,
    pip: false,
    playing: true,
    controls: false,
    light: false,
    volume: 0.8,
    muted: false,
    played: 0,
    loaded: 0,
    duration: 0,
    playbackRate: 1.0,
    loop: false
  });
  const classes = useStyles();

  const handleSeekMouseDown = () => {
    setPlayer({ ...player, seeking: true });
  };

  const desliza = (event, newValue) => {
    setPlayer({ ...player, played: parseFloat(newValue) });
  };

  const deslizaVolume = (event, newValue) => {
    setPlayer({ ...player, volume: parseFloat(newValue) });
  };

  const handleSeekMouseUp = (event, newValue) => {
    console.log('Levantou o mouse!');
    console.log(newValue);
    ref.current.seekTo(parseFloat(newValue));
    setPlayer({ ...player, seeking: false });
  };

  const handlePlayPause = () => {
    setPlayer({ ...player, playing: !player.playing });
  };

  const handleMute = () => {
    setPlayer({ ...player, muted: !player.muted });
  };

  const handlePlay = () => {
    console.log('onPlay');
    setPlayer({ ...player, playing: true });
  };

  const handlePause = () => {
    console.log('onPause');
    setPlayer({ ...player, playing: false });
  };

  const handleProgress = (state) => {
    console.log('onProgress', state);
    if (!player.seeking) {
      setPlayer({ ...player, state });
    }
  };

  const handleDuration = (duration) => {
    console.log('onDuration', duration);
    setPlayer({ ...player, duration });
  };

  const handleEnded = () => {
    console.log('onEnded');
    setPlayer({ ...player, playing: player.loop });
  };
  console.log(player);
  const {
    url,
    playing,
    controls,
    light,
    volume,
    muted,
    loop,
    playbackRate,
    state,
    pip
  } = player;
  return (
    <>
      <ReactPlayer
        ref={ref}
        className="react-player"
        url={url}
        pip={pip}
        playing={playing}
        controls={controls}
        light={light}
        loop={loop}
        playbackRate={playbackRate}
        volume={volume}
        muted={muted}
        onReady={() => console.log('onReady')}
        onStart={() => console.log('onStart')}
        onPlay={handlePlay}
        onPause={handlePause}
        onBuffer={() => console.log('onBuffer')}
        onSeek={(e) => console.log('onSeek', e)}
        onEnded={handleEnded}
        onError={(e) => console.log('onError', e)}
        onProgress={handleProgress}
        onDuration={handleDuration}
        width={width}
        height={height}
      />
      <Grid
        container
        className={classes.player}
        alignContent="center"
        alignItems="center"
        justify="space-evenly"
        spacing={1}
      >
        <Grid
          item
        >
          <IconButton
            onClick={handlePlayPause}
          >
            {playing ? (
              <Pause
                className={classes.play}
              />
            ) : (
              <PlayArrow
                className={classes.play}
              />
            )}
          </IconButton>
        </Grid>
        <Grid
          item
          xs={7}
        >
          <PrettoSlider
            min={0}
            max={0.999999}
            step={0.1}
            value={state ? state.played : 0}
            onChange={desliza}
            onMouseDown={handleSeekMouseDown}
            onChangeCommitted={handleSeekMouseUp}
            defaultValue={0}
            aria-labelledby="continuous-slider"
          />
        </Grid>
        <Grid
          item
        >
          <IconButton
            onClick={handleMute}
          >
            {muted ? (
              <VolumeOff
                className={classes.play}
              />
            ) : (
              <>
                {volume > 0.5 && <VolumeUp className={classes.play} />}
                {(volume <= 0.5 && volume > 0.2) && <VolumeDown className={classes.play} />}
                {volume <= 0.2 && <VolumeMute className={classes.play} />}
              </>
            )}
          </IconButton>
        </Grid>
        <Grid
          item
          xs={2}
        >
          <PrettoSlider
            min={0}
            max={1}
            step={0.1}
            value={volume}
            onChange={deslizaVolume}
            defaultValue={0}
            aria-labelledby="continuous-slider"
          />
        </Grid>
      </Grid>
    </>
  );
};
export default Player;
